import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { Message } from "primereact/message";
import { Password } from "primereact/password";
import React, { Component } from "react";
import { withRouter, RouteComponentProps } from "react-router";
import { Link } from "react-router-dom";
import { auth } from "../../App";

interface Props extends RouteComponentProps {}
interface State {
  email: string;
  password: string;
  failed: boolean;
  pwVergessen: boolean;
  pwVergessenSuccess: boolean;
}

class Login extends Component<Props, State> {
  state = {
    email: "",
    password: "",
    failed: false,
    pwVergessen: false,
    pwVergessenSuccess: false,
  };

  render() {
    return (
      <div className="p-d-flex p-jc-center p-flex-column">
        {this.state.failed && (
          <Message
            severity="error"
            text="Bitte überprüfen Sie Ihre Eingaben"
          ></Message>
        )}
        {this.state.pwVergessenSuccess && (
          <Message
            severity="success"
            text="Falls Sie ein Konto bei uns besitzen wurde Ihnen eine E-Mail zugesandt. Bitte prüfen Sie Ihre E-Mails und Ihren Spam-Ordner"
          ></Message>
        )}
        <span className="p-float-label  p-mt-4 p-mx-auto">
          <InputText
            id="in"
            value={this.state.email}
            onChange={(e) => this.setState({ email: e.target.value })}
            className={this.state.failed ? "p-invalid w-100" : "w-100"}
          />
          <label htmlFor="in">E-Mail</label>
        </span>
        {!this.state.pwVergessen && (
          <span className="p-float-label p-mt-4 p-mx-auto">
            <Password
              toggleMask
              feedback={false}
              value={this.state.password}
              onChange={(e) => this.setState({ password: e.target.value })}
              className={this.state.failed ? "p-invalid w-100" : "w-100"}
            />
            <label htmlFor="in">Passwort</label>
          </span>
        )}
        {!this.state.pwVergessen && (
          <>
            <Link className="p-mx-auto p-mt-4" to="/registrieren">
              Sie haben kein Konto? Jetzt Registrieren
            </Link>
            <span
              onClick={() => {
                this.setState({ pwVergessen: true });
              }}
              style={{
                textDecoration: "underline",
                color: "blue",
              }}
              className="p-mx-auto  p-mt-4 link"
            >
              Passwort vergessen?
            </span>
          </>
        )}
        <br />
        <Button
          label={this.state.pwVergessen ? "E-Mail versenden" : "Login"}
          onClick={async () => {
            if (!this.state.pwVergessen) {
              if (auth) {
                auth
                  .signInWithEmailAndPassword(
                    this.state.email,
                    this.state.password
                  )
                  .then(() => {
                    this.props.history.push("/");
                    window.location.reload();
                  })
                  .catch((error) => this.setState({ failed: true }));
              }
            } else {
              const res = await auth?.sendPasswordResetEmail(this.state.email);
              console.log("test", res, auth);
              this.setState({
                pwVergessenSuccess: true,
                pwVergessen: false,
              });
            }
          }}
        />
      </div>
    );
  }
}
export const LoginWithoutRouter = Login;
export default withRouter(Login);
